import { Pipe, PipeTransform } from '@angular/core';


export enum TemperatureConversion {
  C_F = 'C-F',
  F_C = 'F-C'
}

/**
 * This pipe is used to convert temperatures, e.g. Celsius to Fahrenheit.
 */
@Pipe({
  name: 'convertTemperature',
  pure: true
})
export class MmuTemperaturePipe implements PipeTransform {

  transform(value: number, conversion: TemperatureConversion): number {
    switch (conversion) {
      case TemperatureConversion.F_C:
        return (value - 32) * 5 / 9;
      case TemperatureConversion.C_F:
        return value * 9 / 5 + 32;
    }
  }
}
